// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_fs","advertDetailService__price":"c-p_ft"};